import { SalesChannel } from './user.constants';

export const DOSSIER_ERROR_KEYS = {
  TAXCODE_NOT_FOUND: 'dossier.taxcode.notFound',
  TAXCODE_INVALID: 'dossier.taxcode.invalid',
  COMPANY_TYPE_INVALID: 'dossier.companytype.invalid',
  DOSSIER_ALREADY_EXIST: 'dossier.already.exist',
  DEFAULT: 'default',
};

const composeDossierTranslationKey = (key: string) => `contacts.dossier.${key}`;

const DOSSIER_DIALOG_TITLES = {
  [DOSSIER_ERROR_KEYS.TAXCODE_INVALID]: 'titleConfirm',
  [DOSSIER_ERROR_KEYS.TAXCODE_NOT_FOUND]: 'titleConfirm',
  [DOSSIER_ERROR_KEYS.COMPANY_TYPE_INVALID]: 'titleLegalForm',
};

const DOSSIER_DIALOG_DESCRIPTIONS_SPA = {
  [DOSSIER_ERROR_KEYS.TAXCODE_INVALID]: 'descInvalidSpa',
  [DOSSIER_ERROR_KEYS.TAXCODE_NOT_FOUND]: 'descSpa',
  [DOSSIER_ERROR_KEYS.COMPANY_TYPE_INVALID]: 'descLegalFormSpa',
};

const DOSSIER_DIALOG_DESCRIPTIONS_PEC = {
  [DOSSIER_ERROR_KEYS.TAXCODE_INVALID]: 'descInvalidPec',
  [DOSSIER_ERROR_KEYS.TAXCODE_NOT_FOUND]: 'descPec',
  [DOSSIER_ERROR_KEYS.COMPANY_TYPE_INVALID]: 'descLegalFormPec',
};

export const ERROR_DIALOG_KEYS = new Set([DOSSIER_ERROR_KEYS.TAXCODE_INVALID, DOSSIER_ERROR_KEYS.TAXCODE_NOT_FOUND, DOSSIER_ERROR_KEYS.COMPANY_TYPE_INVALID]);

export const getDialogProperties = (salesChannel: string, errorKey: string) => {
  const isSpaChannel = salesChannel === SalesChannel.SPA;
  return {
    title: composeDossierTranslationKey(DOSSIER_DIALOG_TITLES[errorKey]),
    description: isSpaChannel
      ? composeDossierTranslationKey(DOSSIER_DIALOG_DESCRIPTIONS_SPA[errorKey])
      : composeDossierTranslationKey(DOSSIER_DIALOG_DESCRIPTIONS_PEC[errorKey]),
    btnVisible: isSpaChannel,
  };
};
